import { Route, Routes } from "react-router-dom";
import Home from "../pages";
import MainLayout from "../layout/MainLayout";
import { GeneralRoute } from "./PrivateRoute";

import {
  HOME,
} from "./routes";

function Routers() {
  return (
    <Routes>
      <Route
        path={HOME}
        element={
          <GeneralRoute layout={MainLayout}>
            <Home />
          </GeneralRoute>
        }
       />
    </Routes>
  );
}

export default Routers;
